/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import Vue from 'vue'
import './plugins/fontawesome'
import 'babel-polyfill';

import store from './store/store.js'
import router from './router/router.js'

import './registerServiceWorker.js'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import theme from './plugins/theme.js'
Vue.use(theme)

import App from './App'
import {
  mapMutations
} from 'vuex';

Vue.config.productionTip = false

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});

import customvuetify from './plugins/vuetify'

import './styles/theme.scss'

var vm = new Vue({
  store,
  router,
  render: h => h(App),
  vuetify: customvuetify,
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();

    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll();

    window.addEventListener('beforeinstallprompt', (event) => {
      try {
        event.prompt();
        //eslint-disable-next-line
      } catch (err) {}
    });
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapMutations(['handleResize', 'handleScroll'])
  }
})

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
VueCookies.config('1d')

import util from './common/util.js'
Vue.use(util, {
  vm: vm
})

vm.$mount('#app')